import { render, staticRenderFns } from "./pFileSearch.vue?vue&type=template&id=65b3891d&scoped=true"
import script from "./pFileSearch.vue?vue&type=script&lang=js"
export * from "./pFileSearch.vue?vue&type=script&lang=js"
import style0 from "./pFileSearch.vue?vue&type=style&index=0&id=65b3891d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b3891d",
  null
  
)

export default component.exports